const empty = value => value == null || value === '';

export function queryVehicleId(value) {
  if (empty(value)) return null;
  const id = Number(value);
  if (!Number.isSafeInteger(id) || id <= 0) throw new Error('Choose a valid vehicle before saving.');
  return id;
}

export function selectQueryVehicle(form, value) {
  // Select resets/options loading must never express a destructive clear.
  if (empty(value)) return form;
  return { ...form, vehicle_id: queryVehicleId(value), _vehicleWasChosen: true, _vehicleCleared: false };
}

export const clearQueryVehicle = form => ({ ...form, vehicle_id: null, _vehicleWasChosen: false, _vehicleCleared: true });

export function draftVehicleFields(form, baseline) {
  // Without an authoritative loaded baseline, preserve the saved relationship.
  if (!baseline || !Object.prototype.hasOwnProperty.call(baseline, 'vehicle_id')) return {};
  const selected = queryVehicleId(form.vehicle_id), saved = queryVehicleId(baseline.vehicle_id);
  if (selected === saved) return {};
  if (selected === null && form._vehicleCleared !== true) return {};
  return { vehicle_id: selected };
}

export function createVehicleFields(form) {
  const id = queryVehicleId(form.vehicle_id);
  if (id === null && form._vehicleWasChosen === true && form._vehicleCleared !== true) {
    throw new Error('The selected vehicle is missing. Choose it again before creating the query.');
  }
  return { vehicle_id: id };
}

export function restoreQueryVehicle(saved, baseline) {
  if (!Object.prototype.hasOwnProperty.call(saved, 'vehicle_id') && !Object.prototype.hasOwnProperty.call(baseline || {}, 'vehicle_id')) return saved;
  if (!empty(saved.vehicle_id)) return { ...saved, _vehicleWasChosen: true, _vehicleCleared: false };
  if (saved._vehicleCleared === true) return clearQueryVehicle(saved);
  // Old local drafts stored null even when the server still had a vehicle.
  return { ...saved, vehicle_id: baseline?.vehicle_id ?? null, _vehicleCleared: false,
    _vehicleWasChosen: saved._vehicleWasChosen === true || !empty(baseline?.vehicle_id) };
}
